import React, { useState, useEffect } from 'react';
import TransactionApi from '../api/TransactionApi';
import ContactDropdown from '../component/dropdown/ContactDropdown';
import CategoryApi from '../api/CategoryApi';
import AccountApi from '../api/AccountApi';
import SettingApi from '../api/SettingApi';
import ContactApi from '../api/ContactApi';

const TransactionForm = ({ transactionId, onSubmits, toogle, invoiceData, modal, currentPosts, paidAmount }) => {
  const nonce = devsAccountingApi.nonce;
  const [category, setCategory] = useState([]);
  const [account, setAccount] = useState([]);
  const [message, setMessage] = useState('');
  const [fetchingData, setFetchingData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [setting, setSetting] = useState([]);
  const [errors, setErrors] = useState({});
  const [contact, setContact] = useState([]);
  const liveDate = new Date().toISOString().split("T")[0];

  const [state, setState] = useState({
    paid_at: new Date().toISOString().split('T')[0],
    amount: '',
    amountpaid: '',
    description: '',
    type: '',
    category_id: '1',
    account_id: '',
    payment_method: '',
    nonce: nonce
  });

useEffect(() => {
  getAccount(); 
  getSettings();
  getContact();
  getCategory();
}, []);

  useEffect(() => {
    if (transactionId) {
      getTransaction(transactionId);
    }
  }, [transactionId]);


  useEffect(() => {
  if (invoiceData) {
    const {id, ...rest} = invoiceData;
    const updatedState = {
      ...rest,
      document_id: id,
      type: invoiceData.type === 'bill' ? 'expense' : 'income',
      account_id: invoiceData.contact_id,
      amount: invoiceData.amount - invoiceData.discount-paidAmount,
      paid_at: new Date().toISOString().split('T')[0],
    };
    setState(updatedState);
    
  }
  
}, [invoiceData]);


  const getTransaction = async (transactionId) => {
    setFetchingData(true);
    const res = await TransactionApi.show(transactionId);
    if (res) {
      setFetchingData(false);
      setState((prevState) => ({
        ...prevState,
        ...res,
        paid_at: res.paid_at.split(' ')[0], 
      }));
    }
  };

  const getCategory = async () => {
    const res = await CategoryApi.index(); 
    setCategory(res);
  };

  const getSettings = async () => {
    const res  = await SettingApi.index();
    setSetting(res);
  };

  const getAccount = async () => {
    const res = await AccountApi.index();
    setAccount(res);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

   
    if (name === 'type') {
      getCategory(value);
    }

  
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    
  };

  const accountOptions = account.map((acc) => ({
    value: acc.id,
    label: acc.bank_name,
  }));

  const categoryOptions = category.map((cat) => ({
    value: cat.id,
    label: cat.name,
  }));

  const typeOptions = [
    { value: 'income', label: 'Income' },
    { value: 'expense', label: 'Expense' },
  ];

  const paymentOptions = setting.payment
  ? setting.payment.map(payment => {
      const trimmedPayment = payment.trim();
      return {
        value: trimmedPayment,
        label: trimmedPayment
      };
    })
  : [];

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await TransactionApi.save(state);
    setErrors('')
    if (res.errors) {
        setErrors(res.errors);
        setLoading(false);
    } else {
        setMessage(res.message);
        setLoading(false);
        onSubmits();
        toogle();
    }
    setLoading(false);
  };

  const customerOptions = currentPosts?.map(customerItem => ({
    value: customerItem.id,
    label: customerItem.cat_name,
}));


const getContact = async () => {
  const res = await ContactApi.index();
  
  if (!Array.isArray(res)) {
      setContact(res.data);
   
      const contactOptions = res.data.map((acc) => ({
        value: acc.id,
        label: acc.name,
      }));
      setContact(contactOptions)
  } else {
      console.error("API response is not an array:", res);
  }
};

  return (
    <div>
    {message && (
      <div className="bg-blue-100 border-t border-b border-blue-500 text-blue-700 px-4 py-3" role="alert">
        <p className="font-bold">{message}</p>
      </div>
    )}
    {!fetchingData ? (
      <section className="p-6 mx-auto rounded-md">
        <form onSubmit={handleSubmit}>
          <div className="grid grid-cols-2">
            <div>
              <h2 className="text-lg font-semibold text-gray-700 capitalize">{transactionId ? 'Edit' : 'Add'} Transaction</h2>
            </div>
            <div className="flex justify-end">
              <button
                type="submit"
                className="px-6 py-2 leading-5 text-white transition-colors duration-200 transform bg-gray-700 rounded-md hover:bg-gray-600 focus:outline-none"
              >
                {loading ? 'Submitting...' : 'Submit'}
              </button>
            </div>
          </div>
          <div className="mt-4 flex gap-6">
            <div className="w-7/12 gap-4">
              <div>
                <label className="text-gray-700" htmlFor="paid_at">
                  Paid At
                </label>
                <input
                  id="paid_at"
                  type="date"
                  className="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md focus:border-blue-500 focus:outline-none"
                  name="paid_at"
                  value={state.paid_at}
                  onChange={handleChange}
                  
                />
                {errors.paid_at && <p className="text-red-500 text-xs mt-1">{errors.paid_at}</p>}
              </div>
              <div className="mt-2">
                <label className="text-gray-700" htmlFor="amount">
                  Amount
                </label>
                <input
                  id="amount"
                  type="number"
                  className="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md focus:border-blue-500 focus:outline-none"
                  name="amount"
                  value={state.amount}
                  onChange={handleChange}
                  
                />
                {errors.amount && <p className="text-red-500 text-xs mt-1">{errors.amount}</p>}
              </div>
              {modal !== 'true' && (
                <div className="mt-2">
                  <label className="text-gray-700" htmlFor="description">
                    Description
                  </label>
                  <textarea
                    id="description"
                    type="text"
                    className="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md focus:border-blue-500 focus:outline-none"
                    name="description"
                    value={state.description}
                    onChange={handleChange}
                  />
                  {errors.description && <p className="text-red-500 text-xs mt-1">{errors.description}</p>}
                </div>
              )}
            </div>

            <div className="w-5/12 gap-4">
              {invoiceData?(
                <div className='hidden'>
                <label className="text-gray-700" htmlFor="type">
                  Type
                </label>
                <div className="mt-2">
                  <ContactDropdown options={typeOptions} onSelectChange={handleChange} name="type" selectedValue={state.type} />
                </div>
                {errors.type && <p className="text-red-500 text-xs mt-1">{errors.type}</p>}
              </div>
              ) : (
                <div>
                <label className="text-gray-700" htmlFor="type">
                  Type
                </label>
                <div className="mt-2">
                  <ContactDropdown options={typeOptions} onSelectChange={handleChange} name="type" selectedValue={state.type} />
                </div>
                {errors.type && <p className="text-red-500 text-xs mt-1">{errors.type}</p>}
              </div>

              )}
              
              {/* <div>
                <label className="text-gray-700" htmlFor="type">
                  Type
                </label>
                <div className="mt-2">
                  <ContactDropdown options={typeOptions} onSelectChange={handleChange} name="type" selectedValue={state.type} />
                </div>
                {errors.type && <p className="text-red-500 text-xs mt-1">{errors.type}</p>}
              </div> */}
              {/* add coustomer */}
              {invoiceData?(
                <div className="my-4 hidden">
                <label className="text-gray-700"  htmlFor="contact_id">Customer</label>
                <ContactDropdown options={contact} onSelectChange={handleChange} name="contact_id" selectedValue={state.contact_id} />
                {errors.contact_id && <p className="text-red-500 text-xs mt-1">{errors.contact_id}</p>}
              </div>
              ) :(
              <div className="my-4">
                <label className="text-gray-700"  htmlFor="contact_id">Customer</label>
                <ContactDropdown options={contact} onSelectChange={handleChange} name="contact_id" selectedValue={state.contact_id} />
                {errors.contact_id && <p className="text-red-500 text-xs mt-1">{errors.contact_id}</p>}
              </div>
              )}
              

             {/* {modal !== 'true' && ( */}
                <div className="mt-2">
                  <label className="text-gray-700" htmlFor="category">
                    Category
                  </label>
                  <div className="mt-2">
                    <ContactDropdown options={categoryOptions} onSelectChange={handleChange} name="category_id" selectedValue={state.category_id} />
                  </div>
                  {errors.category_id && <p className="text-red-500 text-xs mt-1">{errors.category_id}</p>}
                </div>
              {/* )} */}
              <div className="flex gap-2 mt-2">
                <div className="w-1/2">
                  <label className="text-gray-700" htmlFor="account_id">
                    Select Account
                  </label>
                  <div className="mt-2">
                    <ContactDropdown options={accountOptions} onSelectChange={handleChange} name="account_id" selectedValue={state.account_id} />
                  </div>
                  {errors.account_id && <p className="text-red-500 text-xs mt-1">{errors.account_id}</p>}
                </div>
                <div className="w-1/2">
                  <label className="text-gray-700" htmlFor="payment_method">
                    Payment Method
                  </label>
                  <div className="mt-2">
                    <ContactDropdown options={paymentOptions} onSelectChange={handleChange} name="payment_method" selectedValue={state.payment_method} />
                  </div>
                  {errors.payment_method && <p className="text-red-500 text-xs mt-1">{errors.payment_method}</p>}
                </div>
              </div>
            </div>
          </div>
        </form>
      </section>
    ) : (
      <div className="m-auto">
        <p className="text-2xl text-bold text-center">Loading...</p>
      </div>
    )}
  </div>
  );
};

export default TransactionForm;
